/* global Wix, window */
import React, {PropTypes} from 'react';
import Chat from '../Chat/Chat';
import {connect} from 'react-redux';
import {expandChat, collapseChat, technicalError, updateDesign, updateLayout, updateTexts} from '../../actions';
import {DEFAULT_CHAT_SETTINGS} from 'inbox-common';
import {EDITOR_VIEW_MODE} from '../../constants/editor-view-mode';
import serverApi from '../../services/serverApi';
import globals from '../../services/globals';
import History from '../../services/history';
import wix from '../../utils/wix';
import {withExperiments} from 'wix-experiments-react';
import _ from 'lodash';

class ChatViewerWrapper extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      instanceId: '',
      userSessionToken: ''
    };
  }

  onTextsChange = texts => {
    this.props.dispatch(updateTexts(texts));
  };

  onLayoutChange = layout => {
    this.props.dispatch(updateLayout(layout));
  };

  onDesignChange = design => {
    this.props.dispatch(updateDesign(design));
  };

  onPublicDataChanged = ({design, layout, texts}) => {
    if (design) {
      this.onDesignChange(design);
    }
    if (layout) {
      this.onLayoutChange(layout);
    }
    if (texts) {
      this.onTextsChange(texts);
    }
  };

  setDefaultSettings = setting => () => {
    return this.onPublicDataChanged(_.pick(DEFAULT_CHAT_SETTINGS, setting));
  };

  loadChatSettings = () => ['texts', 'layout', 'design']
    .forEach(setting => Wix.Data.Public.get(setting, {scope: 'APP'},
      this.onPublicDataChanged, this.setDefaultSettings(setting)));

  componentDidMount() {

    wix.resizeWindow(0, 0);

    const {dispatch} = this.props;
    const instanceId = Wix.Utils.getInstanceId();
    const biToken = Wix.Utils.getInstanceValue('biToken');
    globals.instanceId = instanceId;
    globals.biToken = biToken;
    const visitCount = new History(instanceId).visitCount;

    this.loadChatSettings();

    wix.getUserSessionToken()
      .then(userSessionToken => {
        this.setState({instanceId, userSessionToken, visitCount});
      })
      .then(() => {
        if (!wix.isInView(EDITOR_VIEW_MODE.SITE)) {
          Wix.addEventListener('COMPONENT_DELETED', serverApi.setVisibilityOff.bind(serverApi, wix.getInstance()));
          Wix.addEventListener('PUBLIC_DATA_CHANGED', this.onPublicDataChanged);
          Wix.addEventListener('SETTINGS_UPDATED', ({collapse}) => collapse ? this.onCollapse() : this.onExpand('user'));
          Wix.addEventListener('EDIT_MODE_CHANGE', ({editMode}) => editMode === 'editor' ? this.onCollapse() : null);
        }
      })
      .catch(error => {
        dispatch(technicalError(true));
        console.error(error);
      });
  }

  onChatInit(chatService) {
    ['syncPageTitle', 'subscribeForNavigation', 'subscribeForMetadataChange']
      .forEach(f => wix[f](pageName => {
        chatService.goOnlineIfOffline();
        chatService.updatePresence({pageName});
      }));

    wix.subscribeForSessionTokenChange(this.onSessionTokenChange.bind(this));
  }

  onSessionTokenChange(newSessionToken) {
    return newSessionToken;
  }

  onExpand(initiator) {
    this.props.dispatch(expandChat(initiator));
  }

  onCollapse() {
    this.props.dispatch(collapseChat());
  }

  resizeToCollapsedMode = asRounded => asRounded ?
    wix.resizeWindow(90, 90) : wix.resizeWindow(300, 55);

  resizeToExpandedMode = () => wix.resizeWindow(376, 515);

  resizeWindow = ({collapsed, chatSettings}) => {
    collapsed ? this.resizeToCollapsedMode(_.get(chatSettings, 'layout.collapsedAsRounded')) : this.resizeToExpandedMode();
  };

  componentWillUpdate(nextProps) {
    const collapsedChanged = nextProps.collapsed !== this.props.collapsed;
    const collapsedAsRoundedChanged = _.get(this.props.chatSettings, 'layout.collapsedAsRounded', false) !== _.get(nextProps.chatSettings, 'layout.collapsedAsRounded', false);
    const willExpand = !nextProps.collapsed;

    if ((collapsedChanged && willExpand) || collapsedAsRoundedChanged) {
      this.resizeWindow(nextProps);
    }
  }

  componentDidUpdate(prevProps) {
    const collapsedChanged = prevProps.collapsed !== this.props.collapsed;
    const chatVisibleChanged = prevProps.chatVisible !== this.props.chatVisible;
    const didCollapsed = this.props.collapsed;

    if ((collapsedChanged && didCollapsed) || chatVisibleChanged) {
      this.resizeWindow(this.props);
    }
  }

  /* eslint-disable react/jsx-no-bind */
  render() {

    const dummyMode = !wix.isInView(EDITOR_VIEW_MODE.SITE);

    if (this.state.userSessionToken || (dummyMode && this.state.instanceId)) {
      return (
        <Chat
          instanceId={this.state.instanceId}
          sessionToken={this.state.userSessionToken}
          onChatInit={chatService => this.onChatInit(chatService)}
          visitCount={this.state.visitCount}
          dummyMode={dummyMode}
          onCollapse={() => this.onCollapse()}
          onExpand={initiator => this.onExpand(initiator)}
          />);
    } else {
      return null;
    }
  }

  /* eslint-enable react/jsx-no-bind */
}
ChatViewerWrapper.propTypes = {
  collapsed: PropTypes.bool,
  chatVisible: PropTypes.bool,
  dispatch: PropTypes.func,
  chatSettings: PropTypes.object,
  experiments: PropTypes.object
};

function mapStateToProps(state) {
  return {
    collapsed: state.collapsed,
    chatVisible: state.chatVisible,
    chatSettings: state.chatSettings
  };
}

export default withExperiments(connect(mapStateToProps)(ChatViewerWrapper));



// WEBPACK FOOTER //
// ./chat-app/components/ChatViewerWrapper/ChatViewerWrapper.js